import React from "react";
import Image from "next/image";
import { deployCards, deploySubTitle, deployTitle } from "./product";
// import { deployCardImage } from "../images";
import ProductTitle from "./ProductTitle";

type Props = object;

function Deploy({}: Props) {
  return (
    <section id="deploy" className="w-full py-16 md:py-24">
      <ProductTitle
        pillLabel="Deploy"
        title={deployTitle}
        subTitle={deploySubTitle}
      />

      {/* Cards */}
      <div className="mx-auto mt-10 grid max-w-6xl grid-cols-1 gap-4 px-4 sm:grid-cols-2 md:mt-14 md:grid-cols-3 md:gap-6">
        {deployCards.map(({ title, subTitle, image }, idx) => {
          return (
            <article
              key={title}
              className="group relative mx-auto w-full max-w-[330px] overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-zinc-900/50 to-zinc-800/30 p-4 backdrop-blur-sm transition-all duration-300 hover:border-white/20 hover:shadow-xl"
            >
              {/* Subtle background gradient overlay */}
              <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-transparent via-white/5 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

              <div className="relative">
                {/* Number badge */}
                <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 bg-gradient-to-br from-zinc-800 to-zinc-900 text-sm font-medium text-zinc-300 shadow-lg transition-all duration-300 group-hover:border-white/20 group-hover:shadow-xl">
                  {idx + 1}
                </div>

                {/* Visual */}
                <div className="relative mb-5 overflow-hidden rounded-lg">
                  <div className="h-[170px] w-full md:h-[200px]">
                    <Image
                      src={image}
                      alt={title}
                      width={800}
                      height={500}
                      className="h-full w-full object-fill transition-transform duration-300 group-hover:scale-105"
                      sizes="(max-width: 768px) 100vw, 33vw"
                    />
                  </div>
                </div>

                {/* Text */}
                <h3
                  className="font-dm mb-2 text-[16px] font-medium tracking-[-0.03em] md:text-[18px]"
                  style={{
                    background:
                      "linear-gradient(135deg, #FCFCFC 0%, #A0A0A0 50%, #505050 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  {title}
                </h3>
                <p className="font-dm text-[13px] leading-[1.6] tracking-[-0.02em] text-zinc-300 md:text-[14px]">
                  {subTitle}
                </p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default Deploy;
